import {
  FETCH_RESOURCES_REQUEST,
  FETCH_RESOURCES_SUCCESS,
  FETCH_RESOURCES_FAILURE,
  CREATE_RESOURCE_REQUEST,
  CREATE_RESOURCE_SUCCESS,
  CREATE_RESOURCE_FAILURE,
  UPDATE_RESOURCE_REQUEST,
  UPDATE_RESOURCE_SUCCESS,
  UPDATE_RESOURCE_FAILURE,
  DELETE_RESOURCE_REQUEST,
  DELETE_RESOURCE_SUCCESS,
  DELETE_RESOURCE_FAILURE,
} from "./types";

import {
  createResource,
  fetchResources,
  updateResource,
  deleteResource,
} from "../../services/resourceService";


export const fetchResourcesAction = () => async (dispatch) => {
  dispatch({ type: FETCH_RESOURCES_REQUEST });

  try {
    const response = await fetchResources();

    if (response.success) {
      dispatch({ type: FETCH_RESOURCES_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: FETCH_RESOURCES_FAILURE, payload: response.error });
    }
  } catch (error) {
    dispatch({
      type: FETCH_RESOURCES_FAILURE,
      payload: error.message || "Failed to fetch resources",
    });
  }
};


export const createResourceAction = (formData) => async (dispatch) => {
  dispatch({ type: CREATE_RESOURCE_REQUEST });

  try {
    const response = await createResource(formData);

    if (response.success) {
      dispatch({ type: CREATE_RESOURCE_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: CREATE_RESOURCE_FAILURE, payload: response.error });
    }
  } catch (error) {
    dispatch({
      type: CREATE_RESOURCE_FAILURE,
      payload: error.message || "Failed to create resource",
    });
  }
};

export const updateResourceAction =
  (resourceId, title) => async (dispatch) => {
    dispatch({ type: UPDATE_RESOURCE_REQUEST });

    try {
      const response = await updateResource(resourceId, title);

      if (response.success) {
        dispatch({ type: UPDATE_RESOURCE_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: UPDATE_RESOURCE_FAILURE, payload: response.error });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_RESOURCE_FAILURE,
        payload: error.message || "Failed to update resource",
      });
    }
  };

export const deleteResourceAction = (resourceId) => async (dispatch) => {
  dispatch({ type: DELETE_RESOURCE_REQUEST });

  try {
    const response = await deleteResource(resourceId);

    if (response.success) {
      dispatch({ type: DELETE_RESOURCE_SUCCESS, payload: resourceId });
    } else {
      dispatch({ type: DELETE_RESOURCE_FAILURE, payload: response.error });
    }
  } catch (error) {
    dispatch({
      type: DELETE_RESOURCE_FAILURE,
      payload: error.message || "Failed to delete resource",
    });
  }
};